<template>
  <b-modal
    :id="`advertiser-balance-withdraw-modal`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    size="lg"
    @shown="shown"
    @hidden="hidden"
  >
    <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Retirar saldo - {{ advertiser.name }}</h1>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>
    <div>
      <AlertWraper
        :content="content"
        :type="content_type"
      />
      <div class="mt-4 text-center">
        <div class="mt-3" v-if="step === 'amount'">
          <p>Agora, selecione o quanto você quer retirar de <strong>{{ advertiser.name }}</strong>.</p>
          <p>
            <strong>Saldo de {{ advertiser.name }}</strong>: {{ advertiser.available_amount / 100 | formatMoney }}<br/>
          </p>

          <div class="mt-3">
            <form class="default-form" @submit.prevent="">
              <Money
                class="form-control mb-3"
                v-model.trim="form.amount"
                v-bind="money"
              />
              <label class="form-label fw-semibold text-muted mb-3 required">Motivo da retirada</label>
              <div>
                <!-- Apenas v-model -->
                <textarea
                  class="form-control form-control-solid"
                  placeholder="Digite o motivo"
                  v-model="form.reason"
                ></textarea>
              </div>
              <div class="mt-5">
                <Button
                  class="btn btn-primary"
                  @click="changeStep('confirm')"
                  :disabled="form.amount === 0 || form.amount * 100 > advertiser.available_amount || !form.reason"
                  >
                  Avançar
                </Button>
              </div>
            </form>
          </div>
        </div>
        <div class="mt-3" v-if="step === 'confirm'">
          <p>Você confirma que gostaria de retirar <strong>{{ form.amount | formatMoney }}</strong> do anunciante <strong>{{ advertiser.name }}</strong></p>
          <div class="mt-5 d-flex justify-content-center">
            <Button
              class="btn btn-primary"
              @click="submit"
              :loading="loader"
            >
              Retirar
            </Button>

            <Button
              class="btn btn-danger ms-4"
              @click="changeStep('amount')"
            >
              Voltar
            </Button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import NotificationService from '@/modules/notifications/services/notifications-service'
import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import { Money } from 'v-money'

export default {
  name: 'WithdrawAdvertiserAmountModal',
  props: ['advertiser'],
  components: {
    AlertWraper,
    Button,
    Money
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      form: {
        amount: 0,
        reason: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      loader: '',
      step: 'amount'
    }
  },
  created () {
  },
  methods: {
    changeStep (step) {
      this.step = step
    },
    /**
     * On hidden
    */
    hidden () {
      this.reset()
    },
    /**
     * On shown
    */
    shown () {
      this.reset()
    },
    /**
     * Load more pixels
     */
    async submit () {
      this.loader = true
      this.content = ''
      try {
        await AdvertisersService.withdrawAmount({
          advertiserId: this.advertiser.id,
          amount: this.form.amount * 100,
          reason: this.form.reason
        })
        this.$emit('withdraw', this.advertiser)
        this.$bvModal.hide('advertiser-balance-withdraw-modal')
        const notification = {
          notification: {
            type: 'success',
            content: 'Saldo retirado com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Reset
    */
    reset () {
      this.content = ''
      this.form.amount = 0
      this.form.reason = ''
      this.step = 'amount'
    }
  }
}
</script>
